import { ref, onMounted } from 'vue';

export function useDeviceInfo() {
  const deviceInfo = ref<string>();

  const getDeviceInfo = () => {
    const userAgent = navigator.userAgent;
    const cores = navigator.hardwareConcurrency || 'Unknown';
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const onlineStatus = navigator.onLine ? 'Online' : 'Offline';

    const memory = (navigator as any).deviceMemory || 'Unknown';
    deviceInfo.value =
      `User Agent: ${userAgent}\nCPU Cores: ${cores}\nRAM: ${memory} GB\nScreen Resolution: ${screenWidth}x${screenHeight}\nTime Zone: ${timeZone}\nOnline Status: ${onlineStatus}
    `.trim();
  };

  onMounted(() => {
    getDeviceInfo();
  });

  return {
    deviceInfo,
    getDeviceInfo,
  };
}
